/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {ReactQueryDevtools} from 'react-query/devtools';
import {isDevMode} from '@ion/applications/src/utils/env';

// determines if the deployment environment is development ...
export const isDev = (): boolean => (
  isDevMode() || process?.env?.NODE_ENV === 'development' || false
);

export type DevToolsParams = {
  initialIsOpen?: boolean;
  position?: 'bottom-left' | 'bottom-right'
}

/**
 * The `DevTools` component provides a simple wrapper around ReactQueryDevtools
 * in order to ensure it is only rendered during development.
 *
 * Determining of the deployment environment is based on the presence of an
 * Application defining a `NEXT_PUBLIC_IS_DEV` environment variable (default)
 * via `process.env`, followed by  falling back to `NODE_ENV === 'development'`,
 * and defaulting to `false` if non of the above have been defined.
 */
export const DevTools = memo(({initialIsOpen = false, position = 'bottom-right'}: DevToolsParams) => {
  if (isDev()) {
    return <ReactQueryDevtools initialIsOpen={initialIsOpen} position={position} />;
  }
  return null;
});
export default DevTools;
